import { render } from "./ManualsManagementTab.vue?vue&type=template&id=182290f4&scoped=true"
import script from "./ManualsManagementTab.vue?vue&type=script&lang=js"
export * from "./ManualsManagementTab.vue?vue&type=script&lang=js"

import "./ManualsManagementTab.vue?vue&type=style&index=0&id=182290f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182290f4"]])

export default __exports__